import { render, staticRenderFns } from "./PenilaianPelaksanaanPusat.vue?vue&type=template&id=361b59c3&"
import script from "./PenilaianPelaksanaanPusat.vue?vue&type=script&lang=js&"
export * from "./PenilaianPelaksanaanPusat.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports